import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Cemetery } from "../types/cemetery";

interface CemeterySearchResponse {
  cemeteries: Cemetery[];
  pagination: {
    total: number;
    limit: number;
    offset: number;
    hasMore: boolean;
  };
}

export const cemeterySearchApi = createApi({
  reducerPath: "cemeterySearchApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/cemeteries",
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Cemetery"],
  endpoints: (builder) => ({
    searchCemeteries: builder.query<
      CemeterySearchResponse,
      {
        query?: string;
        limit?: number;
        offset?: number;
      }
    >({
      query: ({ query, limit = 50, offset = 0 }) => ({
        url: "/search",
        params: {
          ...(query && { q: query }),
          limit,
          offset,
        },
      }),
      providesTags: ["Cemetery"],
    }),
  }),
});

export const { useSearchCemeteriesQuery, useLazySearchCemeteriesQuery } =
  cemeterySearchApi;
